import { lazy } from 'react';
export const lazyWithRetry = (factory, onError = () => globalThis.location.reload()) => lazy(() => factory().catch(() => {
    onError();
    return new Promise(() => { });
}));
